exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-0179355d]{margin-top:10px;text-align:right}.over-width[data-v-0179355d]{position:relative;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0179355d","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/base/table/CaseTable.vue
// module id = ISw2
// module chunks = 2